module.exports = __webpack_public_path__ + "img/Vanovy-Logo.ab0d0793.svg";